export default "__VITE_ASSET__1d1d6d31__"